import * as React from 'react';
import {
  SearchableSelect,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui-web';
import { selectStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

const planOptions = [
  { value: 'starter', label: 'Starter' },
  { value: 'growth', label: 'Growth' },
  { value: 'enterprise', label: 'Enterprise' },
];

export function SelectShowcase() {
  const [state, setState] = React.useState<(typeof selectStates)[number]>('default');
  const [basicValue, setBasicValue] = React.useState<string | undefined>('starter');
  const [searchableValue, setSearchableValue] = React.useState<string | null>('ES');
  const disabled = state === 'disabled';

  return (
    <div className="space-y-6">
      <StateToggle options={selectStates} value={state} onChange={setState} label="State" />
      <div className="space-y-4">
        <div className="space-y-2">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Basic
          </p>
          <Select value={basicValue} onValueChange={setBasicValue} disabled={disabled}>
            <SelectTrigger disabled={disabled}>
              <SelectValue placeholder="Select a plan" />
            </SelectTrigger>
            <SelectContent>
              {planOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Searchable
          </p>
          <SearchableSelect
            value={searchableValue}
            onValueChange={setSearchableValue}
            disabled={disabled}
            placeholder="Choose a country"
            labels={{
              trigger: 'Choose a country',
              cancel: 'Cancel',
              searchPlaceholder: 'Search countries',
              searchLabel: 'Search countries',
              clearSearch: 'Clear search',
              empty: 'No countries found',
              shortcuts: 'Shortcuts',
              options: 'All countries',
            }}
            shortcutOptions={[
              { value: 'US', label: 'United States (+1)', searchTokens: ['United States', 'US', '1'] },
              { value: 'ES', label: 'Spain (+34)', searchTokens: ['Spain', 'ES', '34'] },
            ]}
            options={[
              { value: 'AE', label: 'United Arab Emirates (+971)', searchTokens: ['United Arab Emirates', 'AE', '971'] },
              { value: 'ES', label: 'Spain (+34)', searchTokens: ['Spain', 'ES', '34'] },
              { value: 'US', label: 'United States (+1)', searchTokens: ['United States', 'US', '1'] },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
